import { Card, Descriptions, Space, Tag, Typography } from 'antd';
import { SittingSchedule } from '../../lib/api-client.ts';
import { Link } from 'react-router-dom';

type Props = {
  sittingSchedule: SittingSchedule;
};

export const SittingCard = ({ sittingSchedule }: Props) => {
  return (
    <Link to={`/sittings/${sittingSchedule.id}`}>
      <Card
        title={
          <Space align="center">
            {sittingSchedule.status === 'draft' && <Tag color="blue">調整中</Tag>}
            {sittingSchedule.status === 'fixed' && <Tag color="green">確定</Tag>}
            {sittingSchedule.status === 'done' && <Tag color="gray">レポート確認中</Tag>}
            {sittingSchedule.status === 'reported' && <Tag color="processing">レポート済み</Tag>}
            {sittingSchedule.status === 'canceled' && <Tag color="red">キャンセル</Tag>}
            <Typography.Text>{sittingSchedule.user.profile.name || '不明'} 様</Typography.Text>
          </Space>
        }
        hoverable
        bordered={false}
      >
        <Descriptions size="small">
          <Descriptions.Item label="日時">
            {sittingSchedule.startAt} ~ ({sittingSchedule.durationHours}時間)
          </Descriptions.Item>
          <Descriptions.Item label="住所">{sittingSchedule.user.profile.address}</Descriptions.Item>
          <Descriptions.Item label="備考">{sittingSchedule.memo}</Descriptions.Item>
        </Descriptions>
      </Card>
    </Link>
  );
};
